var contactSubmit = {
  submitButton: $('#question_submit'),
  selectBox: $('#question_questionType'),
  phoneInput: $('#question_phoneNumber'),
  customSelect: $('.custom-select'),

  init: function () {
    this.form = this.submitButton.closest('form');
    toastr.options.positionClass = 'toast-top-right';

    var widget = this.form.find('[data-toggle="recaptcha"]')[0];
    if (widget) {
      var widgetType = widget.getAttribute('data-type');
      var widgetSiteKey = widget.getAttribute('data-site-key');
      var widgetParameters = {
        sitekey: widgetSiteKey,
      };
      if (widgetType == 'invisible') {
        widgetParameters['callback'] = function () {
          app.submitForm(app.form.serialize());
        };
        widgetParameters['size'] = 'invisible';
      }
      var widgetId = grecaptcha.render(widget, widgetParameters);
    }

    var app = this;
    this.submitButton.on('click', function (event) {
      $('.form-error').remove();
      if (!app.checkPhoneNumber(app.phoneInput)) {
        event.preventDefault();
        app.phoneInput
          .parent()
          .append(
            '<span class="form-error"><ul><li>' +
              app.phoneInput.data('phone-error') +
              '</li></ul></span>'
          );
        return;
      }
      if (app.selectBox.find(':selected').val() === '') {
        app.selectBox
          .parent()
          .append(
            '<span class="form-error" id="error-select-box"><ul><li>' +
              app.selectBox.data('error') +
              '</li></ul></span>'
          );
        return;
      }
      if (app.form[0].checkValidity()) {
        event.preventDefault();
        var checkbox = $('#checkbox');
        $('.form-error').remove();
        if (checkbox.prop('checked')) {
          // app.submitForm(app.form.serialize());
          grecaptcha.execute(widgetId);
        } else {
          $('.form--agreement')
            .parent()
            .append(
              '<span class="form-error"><ul><li>' +
                checkbox.data('error') +
                '</li></ul></span>'
            );
        }
      }
    });
    this.customSelect.on('click', function (event) {
      $('#error-select-box').remove();
    });
  },
  submitForm: function (serializedForm) {
    var app = this;
    $.ajax({
      url: this.form.attr('action'),
      method: 'POST',
      data: serializedForm,
      beforeSend: function () {
        app.disableButton(true);
      },
      success: function (response) {
        if (response.ok) {
          app.showMessage(response.message, 'success');
          $('#contact-modal').removeClass('modal--show');
          $('body').removeClass('modal-open');
        } else {
          app.showMessage(response.message, 'warning');
        }
      },
      error: function (response) {
        app.showMessage(response.responseJSON.message, 'error');
      },
      complete: function (jqXHR, status) {
        app.enableButton();
        app.form[0].reset();
      },
    });
  },
  showMessage: function (message, type) {
    toastr[type](message);
  },
  disableButton: function () {
    this.submitButton.attr('disabled', 'disabled');
  },
  enableButton: function () {
    this.submitButton.attr('disabled', false);
  },
  checkPhoneNumber: function (element) {
    // var phoneNumber = element.val();
    // var firstNumber = phoneNumber.substring(0, 1);
    //
    // var isnum = /^\d+$/.test(phoneNumber);
    //
    // if (
    //   phoneNumber.length !== 9 ||
    //   (firstNumber !== '6' && firstNumber !== '7') ||
    //   !isnum
    // ) {
    //   return false;
    // }

    return true;
  },
};

function onloadCallback() {
  contactSubmit.init();
}

// $(function () {
//   contactSubmit.init();
// });
